import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { Box, Button, CircularProgress, Stack } from "@mui/material";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  Color,
  EduPostTypes,
  FontStyle,
  JobDisplays,
  Slug,
  SurveyButtonStyle,
} from "../../constants";
import FullTextPanel from "./FullTextPanel";

const styles = {
  arrow: (disabled) => ({
    position: "fixed",
    cursor: "pointer",
    zIndex: 102,
    color: !disabled ? "rgba(0,0,0,0.2)" : "transparent",
    fontSize: "2rem",
    transform: "translateY(-50%)",
    transition: "color 0.25s",
    "&:hover": {
      color: !disabled ? "rgba(0,0,0,0.4)" : "transparent",
    },
  }),
};
export const EduForwardArrow = ({ idx, setIdx, posts }) => {
  if (idx >= posts.length - 1) return null;
  return (
    <ArrowForwardIosIcon
      onClick={(e) => {
        e.stopPropagation();
        if (idx < posts.length - 1) setIdx(idx + 1);
      }}
      sx={{
        ...styles.arrow(idx >= posts.length - 1),
        top: "50%",
        right: "0px",
      }}
    />
  );
};
export const EduBackArrow = ({ idx, setIdx, posts }) => {
  if (idx <= 0) return null;
  return (
    <ArrowBackIosIcon
      onClick={(e) => {
        e.stopPropagation();
        if (idx > 0) setIdx(idx - 1);
      }}
      sx={{
        ...styles.arrow(idx <= 0),
        top: "50%",
        left: "8px",
      }}
    />
  );
};

const FloatContainer = ({ children, handleClose, opacity }) => {
  return (
    <Stack
      direction="column"
      justifyContent="center"
      alignItems="center"
      onClick={handleClose}
      sx={{
        width: "100%",
        // height: '100%',
        ...FontStyle.body,
        minHeight: "100vh",
        // height: "100%",
        width: "100vw",
        overflow: "scroll",
        zIndex: 101,
        position: "fixed",
        top: 0,
        left: 0,
        backgroundColor: "rgba(0,0,0,0.75)",
        px: { xs: 0, md: 4 },
        py: { xs: 0, md: 4 },
        opacity,
        transition: "opacity 0.5s",
      }}>
      <Box
        sx={{
          position: { xs: "fixed", md: "absolute" },
          top: "0px",
          right: "0px",
          padding: { xs: "16px", md: "2rem" },
          cursor: "pointer",
          // color: { xs: "#888", md: "white" },
          color: "#888",
          zIndex: 2,
          fontSize: { xs: "24px", md: "2rem" },
          lineHeight: "0",
          ...FontStyle.body,
          transition: "color 0.25s",
          "&:hover": {
            color: "#334",
          },
        }}
        onClick={handleClose}>
        x
      </Box>
      {children}
    </Stack>
  );
};

const FullPanelFloat = ({
  posts,
  idx,
  urlPostData,
  setIdx,
  setUrlPostData,
}) => {
  const [opacity, setOpacity] = React.useState(0);

  const post = posts[idx];
  useEffect(() => {
    if (post !== null) {
      setOpacity(1);
    } else {
      setOpacity(0);
    }
  }, [post]);
  const handleClose = () => {
    setUrlPostData((d) => {
      return { ...d, active: false };
    });
    setOpacity(0);
    setTimeout(() => {
      setIdx(null);
    }, 500);
  };

  // error or loading screen, if urlPostData is active and we don't have idx yet
  // if (urlPostData.active && idx === null) {
  //   // eduId is set from the url, but we have not loaded it yet
  //   if (urlPostData.error === true) {
  //     return (
  //       <FloatContainer handleClose={handleClose}>
  //         <Stack
  //           direction="column"
  //           justifyContent="center"
  //           alignItems="center"
  //           sx={{
  //             // white container
  //             borderRadius: JobDisplays.borderRadius,
  //             padding: { xs: JobDisplays.padding, md: "32px" },
  //             backgroundColor: JobDisplays.backgroundColor,
  //             boxShadow: JobDisplays.boxShadow,
  //           }}>
  //           Could not find post
  //         </Stack>
  //       </FloatContainer>
  //     );
  //   }
  //   return (
  //     <FloatContainer handleClose={handleClose}>
  //       <CircularProgress />
  //     </FloatContainer>
  //   );
  // }

  // for future me: firstVideo is used to tell the first video to load yt script
  // if (!post) return null;
  // const { type, data, firstVideo } = post;
  return (
    <FloatContainer handleClose={handleClose} opacity={opacity}>
      {
        // loader/error message, if urlPostData given data from url (and currently loading panel)
        urlPostData.active &&
          idx === null &&
          (urlPostData.error ? (
            <Stack
              direction="column"
              justifyContent="center"
              alignItems="center"
              sx={{
                // white container
                borderRadius: JobDisplays.borderRadius,
                padding: { xs: JobDisplays.padding, md: "32px" },
                backgroundColor: JobDisplays.backgroundColor,
                boxShadow: JobDisplays.boxShadow,
              }}>
              Could not find post
            </Stack>
          ) : (
            <CircularProgress />
          ))
      }
      {idx !== null && post.data && post.type === EduPostTypes.text && (
        <FullTextPanel data={post.data} setIdx={setIdx} opacity={opacity} />
      )}
    </FloatContainer>
  );
};

export default FullPanelFloat;
